import "react-app-polyfill/stable";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import "abortcontroller-polyfill/dist/abortcontroller-polyfill-only";

import "./index.scss";
import { store } from "~/redux";

import App from "./App";

ReactDOM.render(
  <Provider store={store}>
    <App />
  </Provider>,
  document.getElementById("root")
);
